import React from "react";

export const LineGraphIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="59"
            height="59"
            viewBox="0 0 59 59"
            fill="none"
        >
            <rect
                opacity="0.1"
                x="0.710938"
                y="0.837891"
                width="57.9453"
                height="57.9453"
                rx="7.24316"
                fill="#FD1F9B"
            />
            <rect
                x="14.7409"
                y="23.9252"
                width="13.5809"
                height="13.5809"
                stroke="#BB106F"
                stroke-width="2.71619"
            />
            <path
                d="M31.7357 37.2799L39.1846 24.3781L46.6335 37.2799H31.7357Z"
                stroke="#FD1F9B"
                stroke-width="2.71619"
            />
        </svg>
    );
};
